"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverApi3 = exports.getApplicatList = exports.describePlanLicense = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _qs = _interopRequireDefault(require("qs"));
var _getCsrfCode = _interopRequireDefault(require("./getCsrfCode"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const getCommonQuery = uinValue => {
  let uin = uinValue;
  if (uinValue.toLocaleLowerCase().startsWith('o')) {
    uin = uinValue.slice(1);
  }
  const startOwnerUin = _jsCookie.default.get('ownerUin');
  let ownerUin = startOwnerUin;
  if (ownerUin) {
    if (ownerUin.toLocaleLowerCase().startsWith('o')) {
      ownerUin = ownerUin.slice(1);
    }
    if (ownerUin.toLocaleLowerCase().endsWith('g')) {
      ownerUin = ownerUin.slice(0, -1);
    }
    console.log('getCommonQuery--', uin, ownerUin);
  }
  const csrfCode = (0, _getCsrfCode.default)();
  const t = new Date().getTime();
  const query = {
    uin,
    csrfCode,
    t
  };
  if (ownerUin) {
    query.ownerUin = ownerUin;
  }
  return query;
};
const serverApi3 = (queryStr, params, callBack) => {
  return fetch(`https://console.tencentcloud.com/cgi/capi?${queryStr}`, {
    method: 'post',
    mode: 'cors',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
      // 'Access-Control-Allow-Credentials': true,
      // 'Access-Control-Allow-Origin': 'https://www.tencentcloud.com',
      // 'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
      // 'Access-Control-Allow-Headers':
      //   'Content-Type, Content-Length, Authorization, Accept, X-Requested-With, x-request-id',
    },
    body: _qs.default.stringify(params)
  }).then(res => res.json()).then(res => {
    callBack(res.data);
  });
};
exports.serverApi3 = serverApi3;
const getApplicatList = callBack => {
  const uin = _jsCookie.default.get('uin');
  if (!uin) {
    return null;
  }
  const commonQuery = getCommonQuery(uin);
  const params = {
    cmd: 'DescribeAppStatList',
    regionId: '9',
    serviceType: 'trtc',
    data: {
      Version: '2019-07-22',
      GmeFlag: 4,
      Limit: 1000,
      Offset: 0,
      OrderField: 'create_time',
      OrderType: 1,
      Region: 'ap-singapore',
      NeedTags: 0,
      NeedLicense: 0
    }
  };
  const queryObj = _objectSpread({
    cmd: 'DescribeAppStatList',
    action: 'delegate',
    serviceType: 'trtc',
    withLanguage: 1,
    dictId: 2066,
    sts: 1,
    secure: 1,
    version: 3
  }, commonQuery);
  const queryStr = _qs.default.stringify(queryObj);
  const result = serverApi3(queryStr, params, callBack);
  console.log('getApplicatList--result--', result);
  return result;
};
exports.getApplicatList = getApplicatList;
const describePlanLicense = (sdkAppId, callBack) => {
  const uin = _jsCookie.default.get('uin');
  if (!uin || !sdkAppId) {
    return null;
  }
  const commonQuery = getCommonQuery(uin);
  const params = {
    cmd: 'DescribePlanLicense',
    regionId: '9',
    serviceType: 'trtc',
    data: {
      Version: '2019-07-22',
      SdkAppId: sdkAppId,
      Region: 'ap-singapore'
    }
  };
  const queryObj = _objectSpread({
    cmd: 'DescribePlanLicense',
    action: 'delegate',
    serviceType: 'trtc',
    withLanguage: 1,
    dictId: 2066,
    sts: 1,
    secure: 1,
    version: 3
  }, commonQuery);
  const queryStr = _qs.default.stringify(queryObj);
  return serverApi3(queryStr, params, callBack);
};
exports.describePlanLicense = describePlanLicense;